import * as React from 'react';

function HowSkillSetsWork2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={340} height={136} viewBox="0 0 340 136" fill="none" {...props}>
      <path fill="var(--cds-color-grey-25)" d="M0 0h340v136H0z" />
      <g opacity={0.4}>
        <rect
          x={44.5}
          y={12.5}
          width={110}
          height={28.321}
          rx={1.5}
          fill="var(--cds-color-neutral-primary-invert)"
          stroke="var(--cds-color-grey-25)"
        />
        <path d="M44 14a2 2 0 012-2h55.594v29.32H46a2 2 0 01-2-2V14z" fill="var(--cds-color-blue-700)" />
        <path fill="var(--cds-color-neutral-primary-invert)" d="M50.283 18.283h36.651v4.189H50.283z" />
        <path
          fill="var(--cds-color-grey-700)"
          d="M111.019 19.33h15.707v3.142h-15.707zM111.019 25.613h19.896v3.142h-19.896zM111.019 31.896h13.613v3.142h-13.613z"
        />
        <path fill="var(--cds-color-neutral-primary-invert)" d="M50.283 26.66h26.179v4.189H50.283z" />
      </g>
      <rect
        x={44.5}
        y={54.387}
        width={110}
        height={28.321}
        rx={1.5}
        fill="var(--cds-color-neutral-primary-invert)"
        stroke="var(--cds-color-grey-200)"
      />
      <path d="M44 55.887a2 2 0 012-2h55.594v29.32H46a2 2 0 01-2-2v-25.32z" fill="var(--cds-color-blue-700)" />
      <path fill="var(--cds-color-neutral-primary-invert)" d="M50.283 60.17h36.651v4.189H50.283z" />
      <path
        fill="var(--cds-color-grey-700)"
        d="M111.019 61.217h15.707v3.142h-15.707zM111.019 67.5h19.896v3.142h-19.896zM111.019 73.783h13.613v3.142h-13.613z"
      />
      <path fill="var(--cds-color-neutral-primary-invert)" d="M50.283 68.547h26.179v4.189H50.283z" />
      <g opacity={0.4}>
        <rect
          x={44.5}
          y={96.273}
          width={110}
          height={28.321}
          rx={1.5}
          fill="var(--cds-color-neutral-primary-invert)"
          stroke="var(--cds-color-grey-25)"
        />

        <path d="M44 97.773a2 2 0 012-2h55.594v29.321H46a2 2 0 01-2-2v-25.32z" fill="var(--cds-color-blue-700)" />
        <path fill="var(--cds-color-neutral-primary-invert)" d="M50.283 102.057h36.651v4.189H50.283z" />
        <path
          fill="var(--cds-color-grey-700)"
          d="M111.019 103.104h15.707v3.142h-15.707zM111.019 109.387h19.896v3.142h-19.896zM111.019 115.67h13.613v3.142h-13.613z"
        />
        <path fill="var(--cds-color-neutral-primary-invert)" d="M50.283 110.434h26.179v4.189H50.283z" />
      </g>
      <path
        d="M227.218 84.988v-29.06l26.796-14.526 26.796 14.533v29.053l-26.796 14.527-26.796-14.527z"
        fill="var(--cds-color-neutral-primary-invert)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225 54.731L254.014 39 283 54.731v31.463l-28.986 15.731L225 86.187V54.731zm53.578 2.403l-24.564-13.322-24.565 13.322v26.65l24.565 13.329 24.564-13.322V57.134z"
        fill="var(--cds-color-yellow-300)"
      />
      <path
        d="M278.579 57.167l4.449-2.435v31.463l-4.456-2.416.007-26.612zM225 86.186l4.401-2.428 24.654 13.367-.041 4.793L225 86.186zM229.422 57.128L225 54.73 254.014 39l-.028 4.774-24.564 13.354z"
        fill="var(--cds-color-yellow-200)"
      />
      <path
        d="M254.014 57.748l4.394 8.369 9.84 1.339-7.117 6.517 1.678 9.195-8.795-4.338-8.796 4.338 1.679-9.195-7.117-6.517 9.832-1.34 4.402-8.368z"
        fill="var(--cds-color-yellow-200)"
        stroke="var(--cds-color-yellow-300)"
        strokeWidth={1.616}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.167 54v14.167H175v1.666h14.167V84h1.666V69.833H205v-1.666h-14.167V54h-1.666z"
        fill="var(--cds-color-grey-300)"
      />
    </svg>
  );
}

export default HowSkillSetsWork2;
